import React, { useState, useContext, useEffect, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Search,
  InsertLinkOutlined,
  DoDisturbOnOutlined,
} from "@mui/icons-material";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import clsx from "clsx";
import { Box, Grid, Alert, Tooltip, Card, CardContent } from "@mui/material";
import Moment from "moment";

import ViewLinkAdmin from "views/Dialog/ViewLinkAdmin";

import loaderGif from "assets/img/loading.gif";

import { blackColor, cardBodyStyle } from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

export default function TransactionsAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [rows, setRows] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "Referencia",
        field: "reference",
        headerAlign: "center",
        width: 100,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 12, color: blackColor }}
              >{`${params.row.reference}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Cliente",
        field: "client",
        // headerAlign: "center",
        width: 250,
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <b
                style={{ fontSize: 14 }}
              >{`${params.row.client.companyName}`}</b>
            </>
          );
        },
      },
      {
        headerName: "Total a cobrar",
        field: "total",
        headerAlign: "center",
        width: 150,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span style={{ fontSize: 14 }}>{`$${params.row.total}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span>
              {params.value
                ? Moment(params.value).format("DD-MM-YYYY")
                : ""}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 100,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 60,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Ver registro" arrow>
                  <Search style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Ver registro"
              onClick={openViewValue(params)}
            />,
          );
          return actions;
        },
      },
    ],
  });

  useEffect(() => {
    RefreshTable();
  }, []);

  const RefreshTable = () => {
    axios
      .get(`${urlServices}payment-link/transactions-clients`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let dataFinal = response.data.map((data) => {
            const commissionPercentage = parseFloat(
              data.client?.percentage || 0,
            );
            const payTotal = parseFloat(data.total || 0);

            // Cálculo de la comisión
            const commission = (commissionPercentage * payTotal) / 100;

            // Cálculo del total a transferir (total - comisión)
            const transferAmount = payTotal - commission;
            return {
              ...data,
              commissionPayment: commission.toFixed(2),
              commissionPaymentTotal: transferAmount.toFixed(2),
            };
          });

          setRows(dataFinal);
          setLoader(false);
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ...",
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      });
  };

  const openViewValue = (data) => () => {
    setIdRow(data.row);
    setOpenView(true);
  };

  const handleCloseView = () => setOpenView(false);

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Card variant="outlined" sx={{ width: "100%" }}>
      <CardContent>
        {error && <Alert severity="error">{mensageSystem}</Alert>}
        {loader ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          </Grid>
        ) : (
          <Fragment>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <div
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 22 }}
                >
                  <InsertLinkOutlined
                    className={classes.iconFilter}
                    sx={{ fontSize: 38, mr: 1 }}
                  />
                  Requerimientos de cobros pendientes{" "}
                </div>
                <Alert severity="info">
                  Son los retiros de cobros que han solicitado tus clientes.
                </Alert>
              </Grid>
            </Grid>
            <Grid container>
              {rows.length > 0 ? (
                <Grid item xs={12} sm={12}>
                  <Box
                    sx={{
                      "& .super-app.celAll": {
                        fontSize: 12,
                        //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                      },
                      "& .super-app.celActions": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      "& .super-app-theme--header": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      marginTop: 2,
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <DataGrid
                        rows={rows}
                        columns={state.columns}
                        loading={loader}
                        initialState={{
                          pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                          },
                        }}
                        pageSizeOptions={[5, 10, 20, 50]}
                        disableRowSelectionOnClick={true}
                        checkboxSelection={false}
                        rowHeight={140}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            display: "flex",
                            alignItems: "center", // Alineación vertical
                            // justifyContent: 'center', // Alineación horizontal
                            //wordWrap: 'break-word !important',
                            //whiteSpace: 'normal !important',
                          },
                          /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            },*/
                        }}
                        getRowHeight={() => "auto"}
                        //autoHeights
                        autoWidth
                      />
                    </ThemeProvider>
                  </Box>
                </Grid>
              ) : (
                <Grid item xs={12} sm={12} sx={{ my: 10 }}>
                  <center>
                    <DoDisturbOnOutlined sx={{ fontSize: 46, color: "#ccc" }} />
                    <br></br>
                    <b
                      style={{
                        fontSize: 18,
                        margin: "5px 0 70px 0",
                        color: "#ccc",
                      }}
                    >
                      No hay registros para mostrar
                    </b>
                  </center>
                </Grid>
              )}
            </Grid>
          </Fragment>
        )}
        {openView && (
          <ViewLinkAdmin open={openView} exit={handleCloseView} id={idRow} />
        )}
      </CardContent>
    </Card>
  );
}
